import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const supplierPaymentsService = {
    uploadWorkItemFiles,
    getWorkItemFileSchemas,
    uploadWorkItemFileList
}

function uploadWorkItemFiles(formData) {
    return axios({
        method: "POST",
        url: "/api/admin/v1/supplierpayments/uploadworkitemfiles",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

function getWorkItemFileSchemas() {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/workitemfileschemas"
    });
}

function uploadWorkItemFileList(formData) {
    return axios({
        method: "GET",
        url: "/api/admin/v1/supplierpayments/workitemfiles",
        //data: formData,
        //headers: {
        //    "Content-Type": "multipart/form-data",
        //},
    });
}